export const COMMISSION_RATE = 0.12; // 12%
export const FREE_MONTHS = 3;
export const CURRENCY = "TJS";
export const CURRENCY_SYMBOL = "с.";

/** Разовая оплата за рассмотрение заявки на бейдж «Проверено» (сомони). */
export const LISTING_VERIFICATION_FEE_TJS = 30;
/** Сервисный сбор за верификацию Rent-a-car компании (сомони). */
export const VENDOR_VERIFICATION_SERVICE_FEE_TJS = 200;

/** Города для фильтра, SEO-посадочных /cars/city/ и sitemap. */
export const VENDOR_ADDRESS_CITY_FILTERS = [
  "Душанбе",
  "Худжанд",
  "Бохтар",
  "Куляб",
  "Хорог",
  "Турсунзаде",
  "Истаравшан",
  "Вахдат",
  "Пенджикент",
  "Канибадам",
] as const;

const CITY_SLUG_MAP: Record<string, string> = {
  Душанбе: "dushanbe",
  Худжанд: "khujand",
  Бохтар: "bokhtar",
  Куляб: "kulob",
  Хорог: "khorog",
  Турсунзаде: "tursunzade",
  Истаравшан: "istaravshan",
  Вахдат: "vahdat",
  Пенджикент: "penjikent",
  Канибадам: "kanibadam",
};

const SLUG_CITY_MAP = Object.fromEntries(
  Object.entries(CITY_SLUG_MAP).map(([city, slug]) => [slug, city])
) as Record<string, string>;

export function cityNameToSlug(city: string): string {
  return CITY_SLUG_MAP[city] ?? city.toLowerCase().replace(/\s+/g, "-");
}

export function citySlugToName(slug: string): string | null {
  return SLUG_CITY_MAP[slug] ?? null;
}

export function knownCitySlugs(): string[] {
  return VENDOR_ADDRESS_CITY_FILTERS.map(cityNameToSlug);
}

export {
  BRANDS,
  BRAND_MODELS,
  CAR_COLOR_OPTIONS,
  ENGINE_VOLUME_OPTIONS,
  BODY_TYPE_OPTIONS,
  CAR_YEAR_MIN,
  CAR_YEAR_MAX,
  carYearOptions,
  colorLabel,
  bodyTypeLabel,
  engineVolumeLabel,
  modelsForBrand,
} from "./car-catalog-options";

export const CAR_FILTERS = {
  transmission: ["manual", "automatic"] as const,
  fuel_type: ["petrol", "diesel", "electric", "hybrid"] as const,
  seats: [2, 4, 5, 6, 7, 8] as const,
};

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  pending: "Ожидает",
  confirmed: "Подтверждено",
  active: "Активно",
  completed: "Завершено",
  cancelled: "Отменено",
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  unpaid: "Не оплачено",
  paid: "Оплачено",
  refunded: "Возврат",
};
